module.exports = __webpack_public_path__ + "static/img/badge_vr_dark.d57505e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badges/badge_vr_dark.svg
// module id = 2612
// module chunks = 0